import React, { useEffect, useState } from 'react';
import styles from './HeroSection.module.scss';
import logoImage from '../assets/73b51d47-7231-4a1e-b3d0-c8447cda18a4.png';
import { motion } from 'framer-motion';
import MuxPlayer from '@mux/mux-player-react';

const HeroSection = () => {
  const scrollToTimeline = () => {
    const timelineSection = document.getElementById("timeline");
    if (timelineSection) {
      timelineSection.scrollIntoView({ behavior: "smooth" });
    }
  };
  
  const redirectToProprIo = () => {
    window.open('https://www.proprt.io/', '_blank');
  };
  
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Set visible immediately for hero section since it's at the top
    setVisible(true);
  }, []);

  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 1.5,
        ease: "easeOut"
      }
    }
  };

  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: {
        duration: 2.0,
        ease: "easeOut" 
      }
    }
  };

  const pulseAnimation = {
    initial: { scale: 1 },
    animate: {
      scale: [1, 1.05, 1],
      transition: {
        duration: 2,
        ease: "easeInOut",
        repeat: Infinity,
        repeatType: "reverse"
      }
    }
  };

  return (
    <section className={styles.hero}>
      <motion.div 
        className={styles.overlay}
        initial="hidden"
        animate={visible ? "visible" : "hidden"}
        variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.5
            }
          }
        }}
      >
        <motion.img 
          src={logoImage} 
          alt="Logo" 
          className={styles.logo}
          variants={fadeIn}
        />
        <motion.h1 
          className={styles.title}
          variants={fadeInUp}
        >
          Australia's first property investing marketplace
        </motion.h1>
        <motion.h2 
          className={styles.subtitle}
          variants={fadeInUp}
        >
          Buy, Sell, Earn. 1-Click
        </motion.h2>
        
        <motion.div
          className={styles.ctaContainer}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 2.5, duration: 0.8 }}
        >
          <motion.button 
            className={styles.primaryCta}
            whileHover={{ scale: 1.05, backgroundColor: '#0c8599' }}
            whileTap={{ scale: 0.98 }}
            onClick={redirectToProprIo}
          >
          Visit Proprt.io
          </motion.button>
          <motion.button 
            className={styles.secondaryCta}
            onClick={scrollToTimeline}
            whileHover={{ scale: 1.05, backgroundColor: 'rgba(255,255,255,0.15)' }}
            whileTap={{ scale: 0.98 }}
          >
            Learn More
          </motion.button>
        </motion.div>
        
        {/* <motion.div 
          className={styles.stats}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 3, duration: 1 }}
        >
          <div className={styles.statItem}>
            <span className={styles.statNumber}>5K+</span>
            <span className={styles.statLabel}>Investments</span>
          </div>
          <div className={styles.statItem}>
            <span className={styles.statNumber}>$10M+</span>
            <span className={styles.statLabel}>Property Value</span>
          </div>
          <div className={styles.statItem}>
            <span className={styles.statNumber}>2.5K+</span>
            <span className={styles.statLabel}>Investors</span>
          </div>
        </motion.div> */}
      </motion.div>
      {/* Mux.com video background */}
      <motion.div 
        className={styles.video}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.5 }}
      >
        <MuxPlayer
          playbackId="dm00b63RYr8J9QHHqWskB00fX32qsACF3y26sWP5ad021I"
          metadata={{
            video_title: 'drone-sydney-harbour-hd-preview.mov',
            viewer_user_id: 'Placeholder (optional)',
          }}
          autoPlay
          loop
          muted
          playsInline
        />
      </motion.div>
      
    
    </section>
  );
};

export default HeroSection;
